/* eslint-disable no-underscore-dangle */
import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {makeSelectCreate} from 'reducers/selectors/fileSelector';
import {makeSelectBasicUser} from 'reducers/selectors/userSelectors';
import {fetchIcons} from 'actions/documentsActions';
import history from 'utils/history';
import FileUploadModal from './FileUploadModal';
import FilesTable from './FilesTable';
import Search from './Search';
import './style.scss';
import 'styles/blog-post-edit.scss';

const basicUserSelector = makeSelectBasicUser();
const Overview = ({folderId}) => {
  const [selected, setSelected] = useState([]);
  const dispatch = useDispatch();
  const iframe = useRef();
  const documents = useSelector((state) => state.documents);

  const basicUser = useSelector(basicUserSelector);
  const [folders, setFolders] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);

  const [uploadFiles, setUploadFiles] = useState(null);
  const folderState = useSelector(makeSelectCreate());
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [pageFilter, setPageFilter] = useState({
    pageSize: 800,
    pageNumber: 0,
  });

  useEffect(() => {
    setTimeout(() => dispatch(fetchIcons(pageFilter)), 200);
  }, []);

  useEffect(() => {
    if (documents.icons.length > 0 && !folders.length) {
      setFolders(documents.icons);
    }
    if (documents.icons.length > 0 && folderId) {
      const folder = documents.icons.find((f) => f.uniqueId === folderId);
      setSelectedFolder(folder);
      setFolders(folder.files);
      if (!breadcrumb.find((f) => f.uniqueId === folder.uniqueId)) {
        const newBreadCrumb = [...breadcrumb];
        newBreadCrumb.push(folder);
        setBreadcrumb(newBreadCrumb);
      }
    }
  }, [documents.icons.length, folderId]);

  return (
    <>
      <iframe
        title="test"
        id="my_iframe"
        ref={iframe}
        style={{display: 'none'}}
      ></iframe>

      {uploadFiles && (
        <FileUploadModal
          folderState={folderState}
          breadcrumb={breadcrumb}
          selected={selectedFolder}
          onClose={() => {
            setUploadFiles(false);
          }}
          onFileUpload={(file) => {
            if (file) {
              const newFolders = [...folders];
              newFolders.push(file);
              setFolders(newFolders);
            }
          }}
        />
      )}

      <div className="tab-box">
        <div className="d-flex mob-flex">
          <div className="tab-content bg-white w-100">
            <Search
              tab={{label: 'Icons'}}
              setSearchKey={setSearchKey}
              searchKey={searchKey}
              onChange={(search) => {
                const newPageFilter = {...pageFilter};
                newPageFilter.searchKey = search;
                setPageFilter(newPageFilter);
              }}
              breadcrumb={breadcrumb}
              selected={selectedFolder}
              onFile={() => setUploadFiles(true)}
              onClick={(folder) => {
                if (!folder) {
                  history.push(`/admin/icons`);
                  setFolders(documents.icons);
                  setBreadcrumb([]);
                } else {
                  const newBreadCrumb = [];
                  breadcrumb.every((f) => {
                    if (f.uniqueId !== folder.uniqueId) {
                      newBreadCrumb.push(f);
                      return true;
                    }
                    newBreadCrumb.push(f);
                    return false;
                  });
                  setBreadcrumb(newBreadCrumb);
                }
              }}
            />

            <>
              {!folderId || (folderId && selectedFolder) ? (
                <FilesTable
                  selected={selected}
                  selectedFolder={selectedFolder}
                  inside={breadcrumb[0]}
                  onDoubleClick={(file) => {
                    if (file.folderType === 'FOLDER') {
                      setSearchKey('');
                      if (
                        !breadcrumb.find((f) => f.uniqueId === file.uniqueId)
                      ) {
                        const newBreadCrumb = [...breadcrumb];
                        newBreadCrumb.push(file);
                        setBreadcrumb(newBreadCrumb);
                      }
                      const folder = documents.icons.find(
                        (f) => f.uniqueId === file.uniqueId
                      );
                      setSelectedFolder(folder);
                      setFolders(folder.files);
                      setSelected([]);
                      history.push(`/admin/icons/${file.uniqueId}`);
                    }
                  }}
                  setSelected={(file) => {
                    let newSelected = [...selected];
                    const exists = newSelected.find(
                      (f) => f.uniqueId === file.uniqueId
                    );

                    if (exists) {
                      newSelected = newSelected.filter(
                        (f) => f.uniqueId !== file.uniqueId
                      );
                    } else {
                      newSelected.push(file);
                    }
                    setSelected(newSelected);
                  }}
                  posts={folders}
                  basicUser={basicUser}
                />
              ) : null}
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default Overview;
